import {
  GIFT_FUND_SOURCE_CATALOG,
  GIFT_FUND_SOURCE_CUSTOM,
  getFundItemDisplayTitle,
  getFundItemProductCode,
} from '../../../api/marketing/gifts/giftFundHelpers'

export const GIFT_FUND_TYPE_FILTER = {
  all: 'all',
  custom: GIFT_FUND_SOURCE_CUSTOM,
  catalog: GIFT_FUND_SOURCE_CATALOG,
}

export const GIFT_FUND_STATUS_FILTER = {
  all: 'all',
  active: 'active',
  inactive: 'inactive',
}

export const GIFT_FUND_GROUP_FILTER_ALL = 'all'

const normalizeSearch = (value) =>
  String(value || '')
    .toLowerCase()
    .trim()

export const filterGiftFundItems = (
  items = [],
  { typeFilter = GIFT_FUND_TYPE_FILTER.all, groupFilter = GIFT_FUND_GROUP_FILTER_ALL, statusFilter = GIFT_FUND_STATUS_FILTER.all, searchQuery = '' } = {}
) => {
  const query = normalizeSearch(searchQuery)

  return items.filter((item) => {
    if (typeFilter !== GIFT_FUND_TYPE_FILTER.all && item.sourceType !== typeFilter) {
      return false
    }

    if (groupFilter !== GIFT_FUND_GROUP_FILTER_ALL && item.rewardGroupId !== groupFilter) {
      return false
    }

    if (statusFilter === GIFT_FUND_STATUS_FILTER.active && item.isActive !== true) {
      return false
    }

    if (statusFilter === GIFT_FUND_STATUS_FILTER.inactive && item.isActive === true) {
      return false
    }

    if (!query) {
      return true
    }

    const title = normalizeSearch(getFundItemDisplayTitle(item))
    const code = normalizeSearch(getFundItemProductCode(item))
    return title.includes(query) || code.includes(query)
  })
}
